import {
  GENDER_OPTIONS,
  WEIGHT_RANGE,
  BODY_FAT_RATE_RANGE,
  LOW_STANDARD_SUFFICIENT,
  LOW_STANDARD_HIGH,
  LOW_HIGH,
  STANDARD_HIGH_EXCESS,
} from '@utils/constant'

export default [
  {
    key: 'gender',
    value: '',
    label: 'gender',
    as: 'radio',
    name: 'gender',
    options: GENDER_OPTIONS,
  },
  {
    lower: 'age_range_lower',
    upper: 'age_range_upper',
    value: {},
    label: 'age',
    appendLabel: '歳',
    name: 'age',
    as: 'numberRanger',
    rules: {
      required: false,
      min: 0,
      max: 150,
      valueRange: { min: 0, max: 150 },
    },
  },
  {
    key: 'slot',
    as: 'slot', // dynamic render item
  },
  {
    lower: 'last_measure_date_lower',
    upper: 'last_measure_date_upper',
    value: {},
    rules: {},
    rulesStart: {
      timeBeforeNow: true,
    },
    rulesEnd: {
      timeBeforeNow: true,
    },
    label: 'lastMeasureDate',
    as: 'dateRanger',
  },
  {
    key: 'weight_range',
    value: [],
    label: 'weightRanger', // 体重
    options: WEIGHT_RANGE,
    as: 'checkboxGroup',
  },
  {
    key: 'body_fat_rate_range',
    value: [],
    label: 'bodyFatRateRange',
    options: BODY_FAT_RATE_RANGE, // 体脂肪率
    as: 'checkboxGroup',
  },
  {
    key: 'body_water_rate_range',
    value: [],
    label: 'bodyWaterRateRange', // 体水分率
    options: LOW_STANDARD_SUFFICIENT,
    as: 'checkboxGroup',
  },
  {
    key: 'BMR_range',
    value: [],
    label: 'bmrRange',
    options: LOW_HIGH, // 基礎代謝
    as: 'checkboxGroup',
  },
  {
    key: 'metabolic_age_range',
    value: [],
    label: 'metabolicAgeRange',
    options: LOW_HIGH, // 体内年齢
    as: 'checkboxGroup',
  },
  {
    key: 'muscle_rate_range',
    value: [],
    label: 'muscleRateRange',
    options: LOW_STANDARD_HIGH, // 骨格筋
    as: 'checkboxGroup',
  },
  {
    key: 'bone_mass_range',
    value: [],
    label: 'boneMassRange',
    options: LOW_STANDARD_HIGH, // 骨量
    as: 'checkboxGroup',
  },
  {
    key: 'subcutaneous_fat_range',
    value: [],
    label: 'subcutaneousFatRange', // 皮下脂肪
    options: LOW_STANDARD_HIGH,
    as: 'checkboxGroup',
  },
  {
    key: 'visceral_fat_range',
    value: [],
    label: 'visceralFatRange', // 内臓脂肪
    options: STANDARD_HIGH_EXCESS,
    as: 'checkboxGroup',
  },
  {
    key: 'BMI_range',
    value: [],
    label: 'bmiRange',
    options: LOW_STANDARD_HIGH, // BMI
    as: 'checkboxGroup',
  },
  {
    key: 'muscle_mass_range',
    value: [],
    label: 'muscleMassRange',
    options: LOW_STANDARD_SUFFICIENT, // 総筋肉量
    as: 'checkboxGroup',
  },
  {
    key: 'protein_range',
    value: [],
    label: 'proteinRange',
    options: LOW_STANDARD_SUFFICIENT, // タンパク質
    as: 'checkboxGroup',
  },
  {
    lower: 'weight_differ_lower',
    upper: 'weight_differ_upper',
    value: {},
    label: 'weightDiffer', // 体重変位
    appendLabel: 'kg',
    as: 'numberRanger',
    rules: {
      required: false,
      max: 100,
      min: -100,
      valueRange: { min: -100, max: 100 },
    },
  },
  {
    lower: 'body_fat_rate_differ_lower',
    upper: 'body_fat_rate_differ_upper',
    value: {},
    label: 'bodyFatRateDiffer', // 体脂肪変位
    appendLabel: '%',
    as: 'numberRanger',
    rules: {
      required: false,
      max: 100,
      min: -100,
      valueRange: { min: -100, max: 100 },
    },
  },
]

export const deliveryTargetFields = {
  gender: 2,
  weight_range: '',
  last_measure_date_lower: '',
  last_measure_date_upper: '',
  age_range_lower: '',
  age_range_upper: '',
  body_fat_rate_range: '',
  body_water_rate_range: '',
  BMR_range: '',
  metabolic_age_range: '',
  muscle_rate_range: '',
  bone_mass_range: '',
  subcutaneous_fat_range: '',
  visceral_fat_range: '',
  BMI_range: '',
  muscle_mass_range: '',
  protein_range: '',
  member_status: '',
  weight_differ_lower: '',
  weight_differ_upper: '',
  body_fat_rate_differ_lower: '',
  body_fat_rate_differ_upper: '',
  admin_note: '',
  answer1: '',
  answer2: '',
  answer3: '',
  answer4: '',
}
